import { render, staticRenderFns } from "./rectangleRadiusController.vue?vue&type=template&id=33c52e18&"
import script from "./rectangleRadiusController.vue?vue&type=script&lang=ts&"
export * from "./rectangleRadiusController.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports